export const NotAssignedAttendant = 'not_assigned';
export const WhatsAppWebAttendant = 'whatsapp_web';
export const BookingAttendant = 'booking_automation';
export const ExpediaAttendant = 'expedia_automation';
export const FacebookAutomationAttendant = 'facebook_automation';
export const GoogleAutomationAttendant = 'google_automation';
/** Control user "Whatsapp Web" (1697): system attendant used by WhatsApp coexistence echoes. */
export const WHATSAPP_WEB_USER_REFERENCE_ID = '1697';
export const WHATSAPP_WEB_ECHO_NAME = 'WhatsApp Web';
